/**
 * Created by zhiyongwang on 2016-04-25.
 */
var en=require("./en.js");
var cn=require("./zh-cn.js");

var Lang=
{

    cn:cn,
    en:en


}


module.exports=Lang;


// WEBPACK FOOTER //
// ./~/wasabiD/Lang/language.js